import data from "../../../../../src/deprecated/UnderlineNav/UnderlineNav.docs.json";
import * as React from 'react';
export default {
  data,
  React
};